import UnreportedSystemsTable from "./UnreportedSystemsTable";

export default UnreportedSystemsTable